import { useCallback, useContext, useEffect } from 'react'
import { X } from 'react-feather'
import { animated } from 'react-spring'
import { useSpring } from 'react-spring/web'
import styled, { ThemeContext } from 'styled-components/macro'

import TransactionPopup from './TransactionPopup'
import { useTransactions } from '../../transactions/TransactionContext'
import { Cross } from '../../catalog/icons/Cross'
import { PopupContent } from './popups'

const Popup = styled.div`
  display: inline-block;
  width: 100%;
  background-color: ${({ theme }) => theme.modalBoxBackground};
  position: relative;
  border-radius: 20px 20px 5px 5px;
  padding: 5px 15px 5px 15px;
  overflow: hidden;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    min-width: 290px;
    &:not(:last-of-type) {
      margin-right: 20px;
    }
  `}
`
const Fader = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: ${({ theme }) => theme.iconColor};
`

const AnimatedFader = animated(Fader)

export default function PopupItem({
  removeAfterMs,
  content,
  popKey,
}: {
  removeAfterMs: number | null
  content: PopupContent
  popKey: string // should be the transaction hash
}) {
  const { transactions, dispatcher } = useTransactions()

  const removeThisPopup = useCallback(
    () => dispatcher({ type: 'unpop', hash }),
    [popKey, dispatcher]
  )
  useEffect(() => {
    if (removeAfterMs === null) return undefined

    const timeout = setTimeout(() => {
      removeThisPopup()
    }, removeAfterMs)

    return () => {
      clearTimeout(timeout)
    }
  }, [removeAfterMs, removeThisPopup])

  let popupContent
  if (!('transaction' in content)) {
    console.error('Unhandled popup content')
    return <div />
    // this was a pattern from Uniswap to handle various contents
  }
  const {
    transaction: {
      submitted: { hash },
    },
  } = content
  popupContent = <TransactionPopup hash={hash} />

  const faderStyle = useSpring({
    from: { width: '100%' },
    to: { width: '0%' },
    config: { duration: removeAfterMs ?? undefined },
  })

  return (
    <Popup>
      <div className={'text-right'}>
        <Cross onClick={() => dispatcher({ type: 'unpop', hash })} />
      </div>

      {popupContent}
      {removeAfterMs !== null ? <AnimatedFader style={faderStyle} /> : null}
    </Popup>
  )
}
